import { useState, useEffect } from 'react';
import axios from 'axios';
import { Radio } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LiveMatches() {
  const [liveMatches, setLiveMatches] = useState([]);

  useEffect(() => {
    const fetchLive = async () => {
      try {
        const { data } = await axios.get(`${API}/matches?status=live`);
        setLiveMatches(data);
      } catch (error) {
        console.error('Failed to fetch live matches:', error);
      }
    };

    fetchLive();
    const interval = setInterval(fetchLive, 15000);
    return () => clearInterval(interval);
  }, []);

  if (liveMatches.length === 0) return null;

  return (
    <div className="bg-gradient-to-r from-[#FF3B30]/20 via-[#FF3B30]/10 to-[#FF3B30]/20 border-y border-[#FF3B30]/30" data-testid="live-matches-ticker">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center gap-4 overflow-x-auto">
          <div className="flex items-center gap-2 flex-shrink-0">
            <Radio className="w-5 h-5 text-[#FF3B30] animate-pulse-live" />
            <span className="text-[#FF3B30] font-bold text-sm uppercase tracking-wider">Live Now</span>
          </div>
          <div className="flex gap-6">
            {liveMatches.map((match) => (
              <div
                key={match.id}
                data-testid={`live-match-${match.id}`}
                className="flex items-center gap-3 text-white whitespace-nowrap"
              >
                <span className="font-semibold">{match.home_team.name}</span>
                <span className="font-mono font-bold text-xl text-[#D4AF37]">
                  {match.home_score} - {match.away_score}
                </span>
                <span className="font-semibold">{match.away_team.name}</span>
                <span className="text-xs text-[#9BA3AF] bg-[#131C2F] px-2 py-1 rounded">
                  {match.stage}
                </span>
                {match.pitch && (
                  <span className="text-xs text-[#0038B8] bg-[#0038B8]/10 px-2 py-1 rounded font-bold">
                    Pitch {match.pitch}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
